var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "drilldown" },
    [
      _c("pui-card", { attrs: { title: "" } }, [
        _c(
          "div",
          {
            directives: [
              { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
            ],
            staticClass: "row",
          },
          [
            _c(
              "p",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: 11,
                    expression: "11",
                  },
                ],
              },
              [
                _c("span", {
                  staticClass: "dot_status",
                  style: { "background-color": _vm.eventStatus[1] },
                }),
                _vm._v(" " + _vm._s(_vm.eventStatus[0]) + " "),
              ]
            ),
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("pui-form-checkbox", {
                  attrs: {
                    label: _vm.$t("info.dominant.dominant"),
                    checked: _vm.isDominantEvent,
                    "is-disabled": !_vm.isDominantEnabled || _vm.isReadOnly,
                  },
                  model: {
                    value: _vm.isDominantEvent,
                    callback: function ($$v) {
                      _vm.isDominantEvent = $$v
                    },
                    expression: "isDominantEvent",
                  },
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "-0.6em",
                      "margin-left": "-2em",
                    },
                  },
                  [
                    _c(
                      "pui-form-group",
                      {
                        attrs: {
                          label: "",
                          "has-info-layer": true,
                          "pui-popover-config": {
                            position: "bottom",
                            headline: "",
                          },
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            attrs: { slot: "pui-popover-content" },
                            slot: "pui-popover-content",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(this.$t("info.dominant.helpText")) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
            ],
            staticClass: "row",
          },
          [
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 4 },
                    expression: "{ s: 12, l: 4 }",
                  },
                ],
                attrs: { label: _vm.$t("id").toUpperCase() },
              },
              [
                _c("pui-form-input-field", {
                  attrs: {
                    type: "text",
                    "is-disabled": true,
                    "placeholder-text": _vm.eventIdentifier,
                  },
                }),
              ],
              1
            ),
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 4 },
                    expression: "{ s: 12, l: 4 }",
                  },
                ],
                attrs: { label: _vm.$t("event-input-title") },
              },
              [
                _c("pui-form-input-field", {
                  attrs: {
                    id: "eventtitlevmodel",
                    type: "text",
                    "is-disabled": _vm.isTitleEnableForUK(
                      _vm.eventInfo.enumAreaSid
                    ),
                    "placeholder-text": _vm.eventInfo.eventTitle,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
            ],
            staticClass: "row",
          },
          [
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 4 },
                    expression: "{ s: 12, l: 4 }",
                  },
                ],
                attrs: { label: _vm.$t("site") },
              },
              [
                _c("pui-form-input-field", {
                  attrs: {
                    type: "text",
                    "is-disabled": true,
                    "placeholder-text": _vm.eventInfo.eventPlantName,
                  },
                }),
              ],
              1
            ),
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 4 },
                    expression: "{ s: 12, l: 4 }",
                  },
                ],
                attrs: { label: _vm.$t("unit") },
              },
              [
                _c("pui-form-input-field", {
                  attrs: {
                    type: "text",
                    "is-disabled": true,
                    "placeholder-text": _vm.eventInfo.eventUnitName,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
            ],
            staticClass: "row",
          },
          [
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 4 },
                    expression: "{ s: 12, l: 4 }",
                  },
                ],
                attrs: { label: _vm.$t("minimalCapacity") + " / [MW]" },
              },
              [
                _c("pui-form-input-field", {
                  attrs: {
                    type: "text",
                    "is-disabled": true,
                    "placeholder-text": _vm.setNumberFormat(
                      _vm.eventInfo.minimalCapacityUnit
                    ),
                  },
                }),
              ],
              1
            ),
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 4 },
                    expression: "{ s: 12, l: 4 }",
                  },
                ],
                attrs: { label: _vm.$t("nominalCapacity") + " / [MW]" },
              },
              [
                _c("pui-form-input-field", {
                  attrs: {
                    type: "text",
                    "is-disabled": true,
                    "placeholder-text": _vm.setNumberFormat(
                      _vm.eventInfo.nominalCapacityUnit
                    ),
                  },
                }),
              ],
              1
            ),
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 12 },
                    expression: "{ s: 12, l: 12 }",
                  },
                ],
                attrs: { label: _vm.$t("description") },
              },
              [
                _c("pui-form-textarea", {
                  attrs: {
                    "is-disabled": true,
                    placeholder: _vm.eventInfo.eventHeaderDto.eventDescription,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
            ],
            staticClass: "row",
          },
          [
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 4 },
                    expression: "{ s: 12, l: 4 }",
                  },
                ],
                attrs: { label: _vm.$t("eventStart") },
              },
              [
                _vm.isParentEvent || _vm.isFirstSplit || _vm.isReadOnly
                  ? _c("pui-form-input-field", {
                      attrs: {
                        type: "text",
                        "trailing-icon-name": "calendar",
                        "is-disabled": true,
                        "placeholder-text": _vm.setDateFormat(_vm.utcStartTime),
                      },
                    })
                  : _c(
                      "pui-date-picker",
                      {
                        staticClass: "event-info__form__row--datepicker",
                        attrs: {
                          show: _vm.showStartTimeDatePicker,
                          "use-calendar": true,
                          "use-input": true,
                          "use-checkbox": false,
                          "days-only": false,
                          "is-range": false,
                          "selectable-range": _vm.getLocalStartTimeRange,
                          start: _vm.localStartTime,
                        },
                        on: {
                          "update:start": function ($event) {
                            _vm.localStartTime = $event
                          },
                          reset: _vm.resetLocalStartTime,
                          apply: _vm.applyLocalStartTime,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "input-with-icon",
                            on: { click: _vm.clickOnStartTime },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.localStartTime,
                                  expression: "localStartTime",
                                },
                              ],
                              staticClass:
                                "pui-form-input-field event-info__form__row--datepicker--input",
                              attrs: { type: "datetime-local", readonly: "" },
                              domProps: { value: _vm.localStartTime },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.localStartTime = $event.target.value
                                },
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "icon" },
                              [
                                _c("pui-icon", {
                                  attrs: {
                                    "icon-name": "calendar",
                                    size: "24px",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
              ],
              1
            ),
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 4 },
                    expression: "{ s: 12, l: 4 }",
                  },
                ],
                staticClass: "event-info__form__row--group",
                attrs: { label: _vm.$t("eventEnd") },
              },
              [
                _vm.isParentEvent || _vm.isLastSplit || _vm.isReadOnly
                  ? _c("pui-form-input-field", {
                      attrs: {
                        type: "text",
                        "trailing-icon-name": "calendar",
                        "is-disabled": true,
                        "placeholder-text": _vm.setDateFormat(_vm.utcEndTime),
                      },
                    })
                  : _c(
                      "pui-date-picker",
                      {
                        staticClass: "event-info__form__row--datepicker",
                        attrs: {
                          show: _vm.showEndTimeDatePicker,
                          "use-calendar": true,
                          "use-input": true,
                          "use-checkbox": false,
                          "days-only": false,
                          "is-range": false,
                          "selectable-range": _vm.getLocalEndTimeRange,
                          start: _vm.localEndTime,
                        },
                        on: {
                          "update:start": function ($event) {
                            _vm.localEndTime = $event
                          },
                          reset: _vm.resetLocalEndTime,
                          apply: _vm.applyLocalEndTime,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "input-with-icon",
                            on: { click: _vm.clickOnEndTime },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.localEndTime,
                                  expression: "localEndTime",
                                },
                              ],
                              staticClass:
                                "pui-form-input-field event-info__form__row--datepicker--input",
                              attrs: { type: "datetime-local", readonly: "" },
                              domProps: { value: _vm.localEndTime },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.localEndTime = $event.target.value
                                },
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "icon" },
                              [
                                _c("pui-icon", {
                                  attrs: {
                                    "icon-name": "calendar",
                                    size: "24px",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
              ],
              1
            ),
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 4 },
                    expression: "{ s: 12, l: 4 }",
                  },
                ],
                attrs: { label: _vm.$t("duration") + " / [h]" },
              },
              [
                _c("pui-form-input-field", {
                  attrs: {
                    type: "text",
                    "is-disabled": true,
                    "placeholder-text": _vm.setNumberFormat(_vm.durationHours),
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "display-group-container" }, [
          _c("h5", { staticClass: "display-group-header" }, [
            _vm._v(" " + _vm._s(_vm.$t("info.singleEvent")) + " "),
          ]),
          _c(
            "div",
            {
              directives: [
                { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
              ],
              staticClass: "row",
            },
            [
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: { label: _vm.$t("unavailableCapacity") + " / [MW]" },
                },
                [
                  _c("pui-form-input-field", {
                    attrs: {
                      id: "singleEventUnAvailCapacity",
                      type: "number",
                      "is-disabled":
                        _vm.isSingleEventDisabled || _vm.isReadOnly,
                      "placeholder-text": _vm.setNumberFormat(
                        _vm.singleEvent.unAvailCapacity
                      ),
                      min: 0,
                      max: _vm.eventInfo.eventHeaderDto.unAvailCapacityUnit,
                    },
                    model: {
                      value: _vm.singleEvent.unAvailCapacityVModel,
                      callback: function ($$v) {
                        _vm.$set(_vm.singleEvent, "unAvailCapacityVModel", $$v)
                      },
                      expression: "singleEvent.unAvailCapacityVModel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: { label: _vm.$t("availableCapacity") + " / [MW]" },
                },
                [
                  _c("pui-form-input-field", {
                    attrs: {
                      type: "text",
                      "is-disabled": true,
                      "placeholder-text": _vm.setNumberFormat(
                        _vm.singleEventAvailableCapacity
                      ),
                    },
                  }),
                ],
                1
              ),
              _c(
                "pui-form-group",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, l: 4 },
                      expression: "{ s: 12, l: 4 }",
                    },
                  ],
                  attrs: { label: _vm.$t("unavailableEnergy") + " / [MWh]" },
                },
                [
                  _c("pui-form-input-field", {
                    attrs: {
                      type: "text",
                      "is-disabled": true,
                      "placeholder-text": _vm.setNumberFormat(
                        _vm.singleEventUnavailableEnergy
                      ),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "center singleEventLabel" }, [
            _c("label", { attrs: { for: "singleEventUnAvailCapacity" } }, [
              _vm._v(" " + _vm._s(_vm.isValueOutsideREACTRange) + " "),
            ]),
          ]),
        ]),
        !_vm.getCurrentSplitEventId
          ? _c("div", { staticClass: "display-group-container" }, [
              _c("h5", { staticClass: "display-group-header" }, [
                _vm._v(" " + _vm._s(_vm.$t("info.react")) + " "),
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "pui-form-grid-row",
                      rawName: "v-pui-form-grid-row",
                    },
                  ],
                  staticClass: "row",
                },
                [
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: { s: 12, l: 4 },
                          expression: "{ s: 12, l: 4 }",
                        },
                      ],
                      attrs: {
                        label: _vm.$t("unavailableCapacity") + " / [MW]",
                      },
                    },
                    [
                      _c("pui-form-input-field", {
                        attrs: {
                          type: "text",
                          "is-disabled": true,
                          "placeholder-text": _vm.setNumberFormat(
                            _vm.eventInfo.eventHeaderDto.unAvailCapacityUnit
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: { s: 12, l: 4 },
                          expression: "{ s: 12, l: 4 }",
                        },
                      ],
                      attrs: { label: _vm.$t("availableCapacity") + " / [MW]" },
                    },
                    [
                      _c("pui-form-input-field", {
                        attrs: {
                          type: "text",
                          "is-disabled": true,
                          "placeholder-text": _vm.setNumberFormat(
                            _vm.eventInfo.eventHeaderDto.availCapacityUnit
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: { s: 12, l: 4 },
                          expression: "{ s: 12, l: 4 }",
                        },
                      ],
                      attrs: {
                        label: _vm.$t("unavailableEnergy") + " / [MWh]",
                      },
                    },
                    [
                      _c("pui-form-input-field", {
                        attrs: {
                          type: "text",
                          "is-disabled": true,
                          "placeholder-text": _vm.setNumberFormat(
                            _vm.eventInfo.eventHeaderDto.unAvailEnergy
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _c(
          "div",
          {
            directives: [
              { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
            ],
            staticClass: "row",
          },
          [
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 4 },
                    expression: "{ s: 12, l: 4 }",
                  },
                ],
                attrs: { label: _vm.$t("info.budgetYear") },
              },
              [
                _c("pui-form-select", {
                  attrs: {
                    label: _vm.$t("info.budgetYear"),
                    "search-input-id": "input-budgetYear-id",
                    options: _vm.yearSelection,
                    required: true,
                    "is-disabled": _vm.isReadOnly || _vm.isNotResultPUB,
                    "search-input-placeholder": "-",
                  },
                  model: {
                    value: _vm.eventInfo.budgetYear,
                    callback: function ($$v) {
                      _vm.$set(_vm.eventInfo, "budgetYear", $$v)
                    },
                    expression: "eventInfo.budgetYear",
                  },
                }),
              ],
              1
            ),
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 4 },
                    expression: "{ s: 12, l: 4 }",
                  },
                ],
                attrs: { label: _vm.$t("info.tractionPower") },
              },
              [
                _c("pui-form-select", {
                  attrs: {
                    label: _vm.$t("info.tractionPower"),
                    "search-input-id": "input-tractionPower-id",
                    "is-disabled": _vm.isReadOnly,
                    options: [
                      {
                        label: this.$t(
                          "defaultValidityModalCancelLabel"
                        ).toString(),
                        value: 0,
                      },
                      {
                        label: this.$t(
                          "defaultValidityModalConfirmLabel"
                        ).toString(),
                        value: 1,
                      },
                    ],
                  },
                  on: {
                    change: function ($event) {
                      return _vm.setTractionPower()
                    },
                  },
                  model: {
                    value: _vm.tractionPower,
                    callback: function ($$v) {
                      _vm.tractionPower = $$v
                    },
                    expression: "tractionPower",
                  },
                }),
              ],
              1
            ),
            _c(
              "pui-form-group",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: { s: 12, l: 4 },
                    expression: "{ s: 12, l: 4 }",
                  },
                ],
                attrs: { label: _vm.$t("flags.mustRun") },
              },
              [
                _c("pui-form-input-field", {
                  attrs: {
                    type: "text",
                    "is-disabled": true,
                    "placeholder-text": _vm.eventInfo.eventHeaderDto.isMustRun
                      ? this.$t("defaultValidityModalConfirmLabel").toString()
                      : this.$t("defaultValidityModalCancelLabel").toString(),
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { key: _vm.translateIndicator, staticClass: "mt-3" },
          [
            _c(
              "pui-tabs",
              { staticClass: "tabs" },
              _vm._l(_vm.tabs, function (tab, index) {
                return _c("pui-tab", { key: index, attrs: { title: tab } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: index == 0,
                          expression: "index == 0",
                        },
                      ],
                    },
                    [
                      _c("EventInfoVgbTab", {
                        ref: _vm.eventInfoVgbTabRef,
                        refInFor: true,
                        attrs: { data: _vm.eventInfo },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: index == 1,
                          expression: "index == 1",
                        },
                      ],
                    },
                    [
                      _c("EventInfoSystemsTab", {
                        ref: _vm.mainAndSubSystemTabRef,
                        refInFor: true,
                        attrs: {
                          "plant-id": _vm.eventInfo.eventPlantSid,
                          "machine-id":
                            _vm.eventInfo.eventHeaderDto.eventMachineSid,
                          "is-tab-active": index == 1,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: index == 2 && _vm.isParentEvent,
                          expression: "index == 2 && isParentEvent",
                        },
                      ],
                    },
                    [
                      _c("AdditionalInfoTab", {
                        ref: _vm.additionalInfoTabRef,
                        refInFor: true,
                        attrs: {
                          "event-data": _vm.eventInfo,
                          "has-required-fields": _vm.hasRequiredFields,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (index == 3 && _vm.isParentEvent) ||
                            (index == 2 && !_vm.isParentEvent),
                          expression:
                            "(index == 3 && isParentEvent) || (index == 2 && !isParentEvent)",
                        },
                      ],
                    },
                    [
                      _c("IndividualEventVgbTab", {
                        ref: _vm.individualEventTabRef,
                        refInFor: true,
                        attrs: {
                          "event-data": _vm.eventInfo,
                          "single-event-unavailable-energy":
                            _vm.singleEventUnavailableEnergy,
                          "has-required-fields": _vm.hasRequiredFields,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
            ],
            staticClass: "buttons",
          },
          [
            _vm.isParentEvent && _vm.isDisplaySplitEventButton
              ? _c("div", [
                  _c(
                    "div",
                    { attrs: { title: _vm.$t("button.split") } },
                    [
                      _c("EventSplit", {
                        staticClass: "mb-2",
                        attrs: {
                          "event-id": _vm.eventInfo.eventId,
                          "start-date": _vm.utcStartTimeForEventSplit,
                          "end-date": _vm.utcEndTime,
                          "next-split-event-id": _vm.getNextSplitEventId,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.isParentEvent && _vm.isDisplayDeleteSplitButton
              ? _c("div", [
                  _c(
                    "div",
                    { attrs: { title: _vm.$t("button.deleteSplit") } },
                    [
                      _c(
                        "pui-lightbox",
                        {
                          ref: "confirmDeletionModalRef",
                          attrs: {
                            "default-header-label": _vm
                              .$t("info.deleteSplit")
                              .toString(),
                            "default-trigger-label": _vm.$t("info.deleteSplit"),
                            "default-footer-confirm-label": "OK",
                            "default-footer-cancel-label": "Cancel",
                            "fit-content": true,
                            fullscreen: false,
                            "on-confirm-callback": _vm.deleteSplitEvents,
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("info.confirmDeleteSplit")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.isDisplaySaveButton
              ? _c("div", [
                  _c(
                    "div",
                    { attrs: { title: _vm.$t("button.save") } },
                    [
                      _c(
                        "pui-button",
                        {
                          staticClass: "mb-2",
                          on: {
                            click: function ($event) {
                              return _vm.saveEventChanges()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.isDisplaySubmitButton
              ? _c(
                  "div",
                  [
                    _c("pui-lightbox", {
                      ref: "submitModalRef",
                      staticClass: "modal",
                      attrs: {
                        "default-header-label": !_vm.submitDialogErrorMessage
                          ? _vm.$t("info.submitModalTitle")
                          : _vm.$t("vgbClassificationRequirements.title"),
                        "default-trigger-label": _vm.$t("info.submit"),
                        "fit-content": true,
                        fullscreen: false,
                        "show-lightbox-close-icon": true,
                        "close-on-overlay-click": false,
                      },
                      on: {
                        "puilightbox:open": _vm.openSubmitDialog,
                        "puilightbox:close": _vm.closeSubmitDialog,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function () {
                              return [
                                _vm.submitDialogErrorMessage
                                  ? _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.submitDialogErrorMessage) +
                                          " "
                                      ),
                                    ])
                                  : _vm.parallelEventsAreAvailable
                                  ? _c(
                                      "div",
                                      { staticClass: "nominatecontent" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "info.submitModalIsparellRelevantHint"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _vm.parallelEventLinks.length
                                          ? _c(
                                              "pui-card",
                                              {
                                                staticClass:
                                                  "mt-2 parallel-card-container",
                                                staticStyle: {
                                                  "justify-content": "center",
                                                },
                                                attrs: { title: "" },
                                              },
                                              _vm._l(
                                                _vm.parallelEventLinks,
                                                function (link, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: link[0] || index,
                                                      staticClass:
                                                        "parallel-event-item",
                                                      staticStyle: {
                                                        display: "flex",
                                                        "flex-direction":
                                                          "column",
                                                        "align-items": "center",
                                                        "justify-content":
                                                          "center",
                                                        flex: "1 0px !important",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          attrs: {
                                                            to: {
                                                              path: `/eventinfo/${link[0]}`,
                                                            },
                                                            target: "_blank",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "pui-button",
                                                            {
                                                              staticStyle: {
                                                                display:
                                                                  "inline-flex",
                                                                "margin-bottom":
                                                                  "0.25em",
                                                              },
                                                              attrs: {
                                                                state:
                                                                  "secondary",
                                                              },
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    link[1]
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "checkbox-box",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.selectedEvents,
                                                                expression:
                                                                  "selectedEvents",
                                                              },
                                                            ],
                                                            staticStyle: {
                                                              width: "20px",
                                                              height: "20px",
                                                              cursor: "pointer",
                                                            },
                                                            attrs: {
                                                              type: "checkbox",
                                                              id: `event-check-${
                                                                link[0] || index
                                                              }`,
                                                            },
                                                            domProps: {
                                                              value: link[0],
                                                              checked:
                                                                Array.isArray(
                                                                  _vm.selectedEvents
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.selectedEvents,
                                                                      link[0]
                                                                    ) > -1
                                                                  : _vm.selectedEvents,
                                                            },
                                                            on: {
                                                              change: [
                                                                function (
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      _vm.selectedEvents,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c =
                                                                      $$el.checked
                                                                        ? true
                                                                        : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v =
                                                                        link[0],
                                                                      $$i =
                                                                        _vm._i(
                                                                          $$a,
                                                                          $$v
                                                                        )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        (_vm.selectedEvents =
                                                                          $$a.concat(
                                                                            [
                                                                              $$v,
                                                                            ]
                                                                          ))
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        (_vm.selectedEvents =
                                                                          $$a
                                                                            .slice(
                                                                              0,
                                                                              $$i
                                                                            )
                                                                            .concat(
                                                                              $$a.slice(
                                                                                $$i +
                                                                                  1
                                                                              )
                                                                            ))
                                                                    }
                                                                  } else {
                                                                    _vm.selectedEvents =
                                                                      $$c
                                                                  }
                                                                },
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.handleParallelEventDominantChange(
                                                                    link[0],
                                                                    $event
                                                                  )
                                                                },
                                                              ],
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "chart-wrapper",
                                            staticStyle: {
                                              "max-width": "100%",
                                            },
                                          },
                                          [
                                            _vm.eventInfo
                                              ? _c("EventParallel", {
                                                  attrs: {
                                                    data: _vm.eventInfo,
                                                    "show-links": false,
                                                    "update-boolean":
                                                      _vm.parallelChartRefreshToken,
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("info.submitModalText")
                                          ) +
                                          " "
                                      ),
                                    ]),
                                _vm.isParentEvent
                                  ? [
                                      _vm.currentAraInformationTabData
                                        .isAssetReliabilityRelevant
                                        ? _c("div", { staticClass: "mt-1" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "info.submitModalIsAraRelevantHint"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _c("div", { staticClass: "mt-1" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "info.submitModalIsNotAraRelevantHint"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                    ]
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "lightbox-footer",
                            fn: function () {
                              return [
                                !_vm.submitDialogErrorMessage
                                  ? _c(
                                      "pui-button",
                                      {
                                        attrs: {
                                          state: "secondary",
                                          disabled: _vm.hasparllelunavailCheck,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmSubmit()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("yes")) + " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.submitDialogErrorMessage
                                  ? _c(
                                      "pui-button",
                                      {
                                        attrs: { state: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.closeSubmitDialog()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("cancel")) + " "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "pui-button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.closeSubmitDialog()
                                          },
                                        },
                                      },
                                      [_vm._v(" OK ")]
                                    ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1816812708
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.isDisplayFinalButton
              ? _c("div", [
                  _c(
                    "div",
                    { attrs: { title: _vm.$t("button.final") } },
                    [
                      _c(
                        "pui-button",
                        {
                          staticClass: "mb-2",
                          on: {
                            click: function ($event) {
                              return _vm.saveAndChangeStatus(744)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("info.final")) + " ")]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.isDisplayReOpenButton
              ? _c("div", [
                  _c(
                    "div",
                    { attrs: { title: _vm.$t("button.reOpen") } },
                    [
                      _c(
                        "pui-button",
                        {
                          staticClass: "mb-2",
                          on: {
                            click: function ($event) {
                              return _vm.saveAndChangeStatus(742)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("info.reOpen")) + " ")]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.isDisplayRequestInfoButton
              ? _c("div", [
                  _c(
                    "div",
                    { attrs: { title: _vm.$t("button.request") } },
                    [
                      _c(
                        "pui-button",
                        {
                          staticClass: "mb-2",
                          on: {
                            click: function ($event) {
                              return _vm.saveAndChangeStatus(742)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("info.requestFurtherInformation")) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }